import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-users-documents-importer',
  templateUrl: './users-documents-importer.component.html',
  styleUrls: ['./users-documents-importer.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UsersDocumentsImporterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
